/*************************************************/
/* MOBILE MENU                                   */
/*************************************************/

export function mobileMenu() {
    const menuButton = document.querySelector(".menu-nav-mobile");
    const mobileMenu = document.querySelector("#mobile-menu");
    const activeOpenClass = "mobile-menu--open";
    const activeClass = "mobile-menu--active";
    const burgerMenu = document.querySelector(".menu-nav-mobile__btn");
    const body = document.body;

    const toggleBodyScroll = () => {
        body.classList.toggle("no-scroll", mobileMenu.classList.contains(activeOpenClass));
    };

    const init = () => {
        menuButton.addEventListener("click", () => {
            mobileMenu.classList.toggle(activeOpenClass);
            burgerMenu.classList.toggle(activeClass);
            toggleBodyScroll(); 
        });

        // Add click event to toggle sub-menu visibility
        const parentItems = document.querySelectorAll('.mobile-menu__main__item--parent > button');
        parentItems.forEach(item => {
            item.addEventListener('click', function (e) {
                item.classList.toggle("mobile-menu__main__link--parent-active");
                const subMenu = this.nextElementSibling; // Get the associated submenu (next <ul>)
                if (subMenu && subMenu.classList.contains('mobile-menu__sub-menu')) {
                    subMenu.classList.toggle('mobile-menu__sub-menu--expanded');
                    subMenu.classList.toggle('mobile-menu__sub-menu--collapsed');
                }
            });
        });
    };

    init();
}

